module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-8-041b46d8717ab1a2c353389257d0486b.png";